import {httpPost} from '@/shared/api/serve/httpPost';
import {CookiesDto} from '@/shared/lib/localStorage/signUp/cookieConsent';

export function saveCookieConsent(payload: CookiesDto) {
  return httpPost('/cookie_policy', payload);
}
